import useAuth from './useAuth';
import { UserRole } from './types';
import { useFeatureFlag, FeatureFlag } from 'hooks/useFeatureFlag';

/**
 * Hook to check if user should be treated as external.
 * Respects the forceExternal feature flag for testing purposes.
 *
 * Usage: Add ?forceExternal=true to the URL to test external user view
 */
export const useIsExternal = (): boolean => {
  const { checkIfRoleIsIncluded } = useAuth();
  const forceExternal = useFeatureFlag(FeatureFlag.FORCE_EXTERNAL);

  if (forceExternal) {
    return true;
  }

  // Otherwise check actual user role
  return checkIfRoleIsIncluded(UserRole.EXTERNAL);
};
